import styled from '@emotion/styled';
import { Column, Layout } from '../../../Layout';
import { mediaQueries } from '../../../../styles/media-queries';
import { pxToRem } from '../../../../styles/utils';

interface ListWrapperProps {
  currentPage: number;
}

interface ListItemProps {
  order?: number;
}

const PAGE_HEIGHT = 456;

export const ListPreloader = styled(Layout)`
  min-height: ${pxToRem(PAGE_HEIGHT)};
`;

export const ListWrapper = styled(Layout)<ListWrapperProps>`
  ${mediaQueries.desktop} {
    justify-content: start;
    height: auto;
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
`;

export const ListItem = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'order'
})<ListItemProps>`
  ${mediaQueries.desktop} {
    order: ${({ order }) => order};
    justify-content: center;
  }
`;

export const LoadMoreButton = styled('button')`
  width: 100%;
  font-weight: 500;
  padding: ${({ theme }) => `${theme.spacing.m}`};
  line-height: ${({ theme }) => `${theme.lineHeight.m}`};
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius.button};
  border: 0;
  outline: 0;
`;
